import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "assets/sass/light-bootstrap-dashboard-pro-react.scss?v=1.2.0";
import "assets/css/demo.css";
import "assets/css/pe-icon-7-stroke.css";

import AuthLayout from "layouts/Auth.jsx";
import AdminLayout from "layouts/Admin.jsx";
import { AuthProvider, useAuth } from "./context/AuthContext";

function AppContent() {
  const { isLogged, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <HashRouter>
      <Switch>
        {!isLogged && (
          <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
        )}
        {isLogged && (
          <Route
            path="/admin"
            render={(props) => <AdminLayout {...props} />}
          />
        )}
        <Redirect to={isLogged ? "/admin/dashboard" : "/auth/login-page"} />
      </Switch>
    </HashRouter>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
